import { FC } from 'react'

import { EuiSpacer } from '@elastic/eui'

import { AIPlanBlueprintPreview } from 'api/entities/AIPlanBlueprintPreview'
import CustomizableSection from 'pages/MasterCampaignPlanPage/new/components/ExecutiveSummary/CustomizableSection'
import RenderCustomSections from 'pages/MasterCampaignPlanPage/new/components/RenderCustomSections'
import TabPageHeader from 'pages/MasterCampaignPlanPage/new/components/TabPageHeader'
import PersonaList from 'pages/MasterCampaignPlanPage/new/components/Personas/PersonaList'

interface AIPlanBlueprintPersonasProps {
  blueprint: AIPlanBlueprintPreview
}

const defaultIntroduction = 'The following personas are descriptive of the types of people we will be targeting. While fictional generalizations, they are based on research and market analysis. They will be used both in the targeting of your ad campaigns and in the crafting of your ads.'

const AIPlanBlueprintPersonas: FC<AIPlanBlueprintPersonasProps> = ({ blueprint }) => {
  const personas = blueprint.personas || []
  const section = blueprint.personasSection

  const pageTitle = section?.pageTitle || 'Persona Prioritization'

  return (
    <>
      <TabPageHeader title={pageTitle} />

      <CustomizableSection section={section?.introduction as any} defaultTitle='' defaultContent={defaultIntroduction} defaultShowTitle={false} separator='spacer' />
      <EuiSpacer size='xl' />

      <RenderCustomSections sections={section?.abovePersonaList as any} />

      <PersonaList personas={personas} />
    </>
  )
}

export default AIPlanBlueprintPersonas
